import {
  handleChatLanguageUpdatedSignal,
  handleContactAdded,
  handleContactPermissionUpdate,
  handleContactRemovedSignal,
  handleGetInvitationList,
  handleOtherWorkspaceSignal,
  memberAddedToGrpSignal,
  updateGroupSignal,
  updateGroupTopicSignal,
} from ".";
import { PubnubEventType } from "../../../utils/constant";
import { SHOULD_CALL_PUBNUB_GET_TOKEN, THREAD_LIST_CHANGED, WORK_TRACKING_CHANGED } from "../../../appStore/actions/AppState/type";
import { handleApplyReadReceipt, handleApplyTopicMove, handleAttachmentsRenamed, handleMessageConfirmed, handleRefreshOpenStarredList, handleTopicOrSubtopicDeleted, requestGetArchiveGroupList } from "../../../appStore/actions/ArkchatGroup/action";
import { UPDATE_THREAD_HEADING } from "../../../appStore/actions/ArkchatGroup/type";
import { ownProfileJustSaved } from "../../../appStore/actions/profile/action";


export function handlePubnubSignal({
  loggedInUserActiveSubsId,
  loggedInUserId,
  allWorkspaces,
  sidList,
  messageEvent,
  dispatch,
  requestallmemberswithgroups,
  setisTopicOpen,
  handleCloseAddPeopleDrawer,
  getAlltopic,
  requestgroupMemberDetails,
  requestGetGroupRecipient,
  requestUpdateFromSignalGroupRecipient,
  groupList,
  groupRecipientDetails,
  switchAccount,
  getProfile,
  switchAccountId,
  requestGetAllAcountLevelMember,
  setGroupname,
  navigate,
  userData,
  saveSelectedAppGroupData,
  handleAppSelectedTopic,
  selectedGroup,
  handleFetchConversation,
  handleUpdateExistingMessage,
  messageList,
  selectedTopic,
  selectedSubtopic,
  isThreadScreen,
  getAllPendingInvitation,
  handleSwitchAccountRefresh,
  switchAccountRefresh,
  handleSyncStarMsgData,
  handleDeleteMsgFromDb,
  toggleSetPubTokenState,
  handleTogglePunbunTokenUpdateState,
  updateGroupArchiveKeyInDb

}) {
  if (
    handleOtherWorkspaceSignal(
      allWorkspaces,
      loggedInUserActiveSubsId,
      loggedInUserId,
      sidList,
      messageEvent?.message?.content,
      dispatch,
      requestallmemberswithgroups,
      getProfile,
    )
  ) {
    return;
  }
  switch (messageEvent?.message?.content?.type) {
    case PubnubEventType?.PROFILE_UPDATE: {
      const content = messageEvent?.message?.content ?? {};
      const changedUsers = (content.uid || []).map(String);
      // An account's own profile (name, logo) shows on its groups, people and
      // DMs everywhere: reload as before. A person's profile only shows where
      // they appear, so reload just the lists that show them (this signal
      // reaches every session in each of their accounts).
      const accountChanged = !!content.account;
      dispatch((d, getState) => {
        const state = getState()?.arkchatgroup || {};
        // A chat shows the person when it's a DM with them, or a group they
        // created (Group Information shows its creator).
        const showsChangedUser = (item) =>
          item?.isGroup
            ? changedUsers.includes(String(item?.createdByUser ?? item?.createdByUserDetails?.userId))
            : String(item?.pnId || "").replace(/^direct\./, "").split("_").some((id) => changedUsers.includes(id));
        const listShowsChange = (list) => {
          if (!Array.isArray(list)) return true; // not loaded yet: can't tell
          if (accountChanged) return list.length > 0;
          return list.some(showsChangedUser);
        };
        if (accountChanged || listShowsChange(state.groupList)) {
          d(requestallmemberswithgroups({ forceFetch: true })); // chats and DMs
        }
        if (listShowsChange(state.archiveGroupList)) {
          d(requestGetArchiveGroupList()); // archived chats and DMs
        }
        d(requestGetAllAcountLevelMember(true)); // contacts
        if (selectedGroup?.id) {
          // members, recipients and assignees of the open group: when the
          // person is in it (or the loaded lists are for another group)
          const members = state.groupmember?.groupId === selectedGroup.id
            ? [...(state.groupmember?.internalMember || []), ...(state.groupmember?.externalMember || [])]
            : null;
          const recipients = state.groupRecipientGroupId === selectedGroup.id && Array.isArray(state.groupRecipient)
            ? state.groupRecipient
            : null;
          const inOpenGroup = (!members && !recipients) ||
            [...(members || []), ...(recipients || [])].some((m) => changedUsers.includes(String(m?.userId)));
          if (accountChanged || inOpenGroup) {
            d(requestgroupMemberDetails({
              group_id: selectedGroup?.id,
              target_subscriber_id:
                loggedInUserActiveSubsId ?? selectedGroup?.subscriberId,
            }));
            d(requestGetGroupRecipient(selectedGroup?.id));
          }
        }
      });
      // My own profile changed on another device or tab, or the active
      // account's own profile (name, logo) changed: re-read my profile, which
      // drives the menu, My Profile, the workspace profile and Switch Account.
      // Not when this device just saved it: the save refreshes it.
      const activeAccountChanged =
        accountChanged && String(content.sid) === String(loggedInUserActiveSubsId);
      if ((changedUsers.includes(String(loggedInUserId)) || activeAccountChanged) && !ownProfileJustSaved()) {
        dispatch(getProfile(true));
      }
      return;
    }
    case PubnubEventType?.MARK_AS_READ: {
      if (
        // loggedInUserActiveSubsId === messageEvent?.message?.content?.sid &&
        messageEvent?.message?.content?.uuid?.includes(loggedInUserId) &&
        messageEvent?.message?.content?.type === PubnubEventType?.MARK_AS_READ
      ) {
        // The signal says who read them: add the tick here. In a group every
        // member's read reached every member, and each re-fetched the
        // messages (members x members requests). Older servers don't say.
        const reader = messageEvent?.message?.content?.reader;
        if (reader) {
          dispatch(handleApplyReadReceipt(messageEvent?.message?.content?.timetoken || [], reader));
          return;
        }
        const reqBody = {
          pn_id: messageEvent?.message?.content?.pnid,
          timetoken: messageEvent?.message?.content?.timetoken,
        };
        let shouldUpdateMessageList = false;
        if (messageEvent?.message?.content?.pnid === selectedGroup?.pnId) {
          shouldUpdateMessageList = true;
        }
        dispatch(handleFetchConversation(reqBody)).then((res) => {
          dispatch(
            handleUpdateExistingMessage(
              messageEvent?.message?.content?.pnid,
              res,
              shouldUpdateMessageList,
              messageList,
              selectedTopic,
              isThreadScreen
            )
          );
        });
      }

      return;
    }

    case PubnubEventType?.CHAT_MOVED_TO_ANOTHER_TOPIC: {
      const content = messageEvent?.message?.content ?? {};
      if (
        loggedInUserActiveSubsId === content.sid &&
        content.uuid?.includes(loggedInUserId)
      ) {
        const reqBody = { pn_id: content.pnid, timetoken: content.timetoken };
        dispatch(handleFetchConversation(reqBody)).then((res) => {
          // Local store and an open thread.
          dispatch(handleUpdateExistingMessage(content.pnid, res));
          // The open chat: all messages, a topic or a subtopic.
          if (content.pnid === selectedGroup?.pnId) {
            dispatch(handleApplyTopicMove(res, selectedTopic?.id, selectedSubtopic?.id));
          }
        });
        // The thread list (filtered by topic/subtopic) and Track Work.
        dispatch({
          type: THREAD_LIST_CHANGED,
          payload: {
            pnId: content.pnid,
            moved: {
              temp_timetokens: content.timetoken || [],
              topicId: content.tid || "",
              subtopicId: content.stid || "",
            },
          },
        });
        dispatch({ type: WORK_TRACKING_CHANGED, payload: { pnId: content.pnid } });
      }
      return;
    }

    case PubnubEventType?.CHAT_STARRED: {
      if (
        loggedInUserActiveSubsId === messageEvent?.message?.content?.sid &&
        messageEvent?.message?.content?.uuid?.includes(loggedInUserId)
      ) {
        let shouldUpdateMessageList = false;
        if (messageEvent?.message?.content?.pnid === selectedGroup?.pnId) {
          shouldUpdateMessageList = true;
        }
        dispatch(
          handleSyncStarMsgData(
            messageEvent?.message?.content?.pnid,
            messageEvent?.message?.content?.message?.temp_timetoken,
            selectedTopic?.id,
            messageList?.length,
            messageEvent?.message?.content?.message,
            shouldUpdateMessageList,
            true, // an open thread showing it (matched by temp_timetoken)
          )
        );
        // The Starred screen, if it's open on this group.
        dispatch(handleRefreshOpenStarredList(messageEvent?.message?.content?.pnid));
      }
      return;
    }
    case PubnubEventType?.CHAT_MSG_DELETE: {
      const content = messageEvent?.message?.content ?? {};
      if ((content.uuid || []).map(String).includes(String(loggedInUserId))) {
        // Remove it from the screen whenever it belongs to the open
        // conversation. The signal's sid isn't needed for that, and chat
        // used to send it as null for "delete for all", which left the
        // message on screen until a refresh.
        dispatch(
          handleDeleteMsgFromDb(
            content.pnid,
            content.temp_timetoken,
            content.sid,
            selectedGroup?.pnId,
            selectedTopic?.id,
            messageList?.length,
            content.pnid === selectedGroup?.pnId
          )
        ).then((affectsChatList) => {
          // Re-read the chat list only if it shows something else now: the
          // deleted message was the chat's last-message preview or unread
          // (badge). Otherwise each delete cost a full chat list load.
          if (affectsChatList !== false) dispatch(requestallmemberswithgroups({ forceFetch: true }));
        });
        dispatch({
          type: THREAD_LIST_CHANGED,
          payload: { pnId: content.pnid, deletedTempTimetoken: content.temp_timetoken },
        });
        // The signal doesn't say whether it was a task/approval; the Track
        // Work tab only refetches when it shows this group.
        dispatch({ type: WORK_TRACKING_CHANGED, payload: { pnId: content.pnid } });
      }

      return;
    }

    case PubnubEventType?.ACCOUNT_INVITATION: {
      handleGetInvitationList(
        loggedInUserActiveSubsId,
        loggedInUserId,
        messageEvent?.message?.content,
        dispatch,
        getAllPendingInvitation
      );
      return;
    }

    case PubnubEventType?.ACCOUNT_SWITCHED: {
      const endpoint = window.location.pathname;
      // With "All" shown what's listed doesn't depend on the active workspace,
      // and it changes for actions in place: nothing to reload or leave.
      if (allWorkspaces) {
        if (messageEvent?.message?.content?.uuid?.includes(loggedInUserId)) {
          dispatch(getProfile(true));
        }
        return;
      }
      if (messageEvent?.message?.content?.uuid?.includes(loggedInUserId)) {
        dispatch(getProfile()).then((Profileres) => {
          if (Object.keys(Profileres).length > 0) {
            dispatch(requestallmemberswithgroups({ forceFetch: true })).then(
              (allgrpres) => {
                if (endpoint !== "/chat") {
                  navigate("/chat");
                }
                dispatch(handleSwitchAccountRefresh(!switchAccountRefresh));
              }
            );
          }
        });
      }
      return;
    }
    case PubnubEventType?.GROUP_CREATED: {
      updateGroupSignal(
        sidList,
        loggedInUserActiveSubsId,
        loggedInUserId,
        messageEvent?.message,
        dispatch,
        requestallmemberswithgroups,
      );
      return;
    }
    case PubnubEventType?.GROUP_DELETED:
    case PubnubEventType?.GROUP_EDITED: {
      updateGroupSignal(
        sidList,
        loggedInUserActiveSubsId,
        loggedInUserId,
        messageEvent?.message,
        dispatch,
        requestallmemberswithgroups,
        selectedGroup,
        setisTopicOpen,
        setGroupname,
        saveSelectedAppGroupData,
        handleSwitchAccountRefresh,
        switchAccountRefresh
      );
      return;
    }
    case PubnubEventType?.GROUP_UNARCHIVED:
    case PubnubEventType?.DM_UNARCHIVED: {
      if (
        loggedInUserActiveSubsId === messageEvent?.message?.content?.sid &&
        messageEvent?.message?.content?.uuid?.includes(loggedInUserId)
      ) {
        
        dispatch(updateGroupArchiveKeyInDb(messageEvent?.message?.data?.pnId||messageEvent?.message?.data?.pubnubChannel,0));
      }
      return;
    }
    case PubnubEventType?.GROUP_ARCHIVED:
    case PubnubEventType?.DM_ARCHIVED: {
      if (
        loggedInUserActiveSubsId === messageEvent?.message?.content?.sid &&
        messageEvent?.message?.content?.uuid?.includes(loggedInUserId)
      ) {
        
        dispatch(updateGroupArchiveKeyInDb(messageEvent?.message?.data?.pnId||messageEvent?.message?.data?.pubnubChannel,1));
      }
      return;
    }
    case PubnubEventType?.USER_GROUP_LIST_UPDATED:
    case PubnubEventType?.USER_ADDED_TO_GROUP:
    case PubnubEventType?.USER_REMOVED_FROM_GROUP:
    case PubnubEventType?.USER_EXITED_THE_GROUP: {
      memberAddedToGrpSignal(
        loggedInUserActiveSubsId,
        loggedInUserId,
        messageEvent?.message?.content,
        dispatch,
        requestallmemberswithgroups,
        requestgroupMemberDetails,
        requestUpdateFromSignalGroupRecipient,
        selectedGroup,
        handleSwitchAccountRefresh,
        switchAccountRefresh,
        sidList
      );
      return;
    }
    case PubnubEventType?.TOPIC_CREATED:
    case PubnubEventType?.TOPIC_UPDATED:
    case PubnubEventType?.TOPIC_DELETED: {
      const topicContent = messageEvent?.message?.content ?? {};
      if (topicContent.type === PubnubEventType?.TOPIC_DELETED) {
        dispatch(handleTopicOrSubtopicDeleted({ groupId: topicContent.gid, topicId: topicContent.tid }));
      }
      updateGroupTopicSignal(
        loggedInUserActiveSubsId,
        loggedInUserId,
        messageEvent?.message?.content,
        dispatch,
        getAlltopic,
        selectedGroup,
        sidList
      );
      return;
    }
    case PubnubEventType?.SUBTOPIC_CREATED:
    case PubnubEventType?.SUBTOPIC_UPDATED:
    case PubnubEventType?.SUBTOPIC_DELETED: {
      const { getAllSubtopicsForGroup } = require("../../../appStore/actions/subtopics/action");
      const content = messageEvent?.message?.content;
      if (content?.type === PubnubEventType?.SUBTOPIC_DELETED) {
        dispatch(handleTopicOrSubtopicDeleted({ groupId: content?.gid, subtopicId: content?.stid }));
      }
      if (content?.gid && selectedGroup?.id === content?.gid) {
        dispatch(getAllSubtopicsForGroup(content?.gid));
      }
      return;
    }

    case PubnubEventType?.CONTACT_REMOVED: {
      handleContactRemovedSignal(
        loggedInUserActiveSubsId,
        loggedInUserId,
        messageEvent?.message?.content,
        dispatch,
        switchAccountId,
        switchAccount,
        getProfile,
        requestallmemberswithgroups,
        requestGetAllAcountLevelMember,
        requestgroupMemberDetails,
        requestGetGroupRecipient,
        selectedGroup,
        navigate,
        userData,
        handleSwitchAccountRefresh,
        switchAccountRefresh,
        groupRecipientDetails
      );
      return;
    }
    case PubnubEventType?.CONTACT_PERMISSION_UPDATED: {
      handleContactPermissionUpdate(
        loggedInUserActiveSubsId,
        loggedInUserId,
        messageEvent?.message?.content,
        dispatch,
        requestGetAllAcountLevelMember,
        getProfile,
        requestallmemberswithgroups,
        selectedGroup,
        requestgroupMemberDetails,
        groupRecipientDetails,
        handleSwitchAccountRefresh,
        switchAccountRefresh,
        requestGetGroupRecipient
      );
      return;
    }
    case PubnubEventType?.CONTACT_ADDED: {
      handleContactAdded(
        loggedInUserActiveSubsId,
        loggedInUserId,
        messageEvent?.message?.content,
        dispatch,
        requestGetAllAcountLevelMember,
        requestallmemberswithgroups,
        requestgroupMemberDetails,
        requestGetGroupRecipient,
        selectedGroup
      );
      return;
    }
    case PubnubEventType?.CHAT_LANGUAGE_UPDATED: {
      handleChatLanguageUpdatedSignal(
        loggedInUserActiveSubsId,
        loggedInUserId,
        messageEvent?.message?.content,
        dispatch,
        requestgroupMemberDetails,
        requestGetGroupRecipient,
        selectedGroup,
        requestGetAllAcountLevelMember,
        sidList
      );
      return;
    }
    case PubnubEventType?.PUBNUB_TOKEN_UPDATE: {
      dispatch({ type: SHOULD_CALL_PUBNUB_GET_TOKEN, payload: true });
      return;
    }
    case PubnubEventType?.MESSAGE_CONFIRMED: {
      const confirmedMsg = messageEvent?.message?.content?.message ?? {};
      if (confirmedMsg.temp_timetoken) {
        dispatch(handleMessageConfirmed(confirmedMsg, selectedGroup?.pnId, messageList));
      }
      // Sent after the save, so the thread list can now be re-read.
      if (confirmedMsg.pnId) {
        dispatch({ type: THREAD_LIST_CHANGED, payload: { pnId: confirmedMsg.pnId } });
        // A task (1) or approval (2) is saved now: Track Work can show it.
        if (confirmedMsg.type === 1 || confirmedMsg.type === 2) {
          dispatch({ type: WORK_TRACKING_CHANGED, payload: { pnId: confirmedMsg.pnId } });
        }
      }
      return;
    }
    case PubnubEventType?.ATTACHMENT_RENAMED: {
      const content = messageEvent?.message?.content ?? {};
      if ((content.uuid || []).map(String).includes(String(loggedInUserId))) {
        dispatch(handleAttachmentsRenamed(content));
      }
      return;
    }
    case PubnubEventType?.THREAD_HEADING_UPDATED: {
      const { id, thread_heading } = messageEvent?.message?.content?.message ?? {};
      if (id) {
        dispatch({ type: UPDATE_THREAD_HEADING, payload: { id, thread_heading } });
        dispatch({ type: WORK_TRACKING_CHANGED, payload: { pnId: messageEvent?.channel } });
      }
      return;
    }
    default:
      return null;
  }
}
